module.exports = __webpack_public_path__ + "media/images/athletes/4323-4d72ecf4e4d466404f49d766929a6d1e.png";